/**
 * CUSTOMER_CHAT_FAST_RESULTS: server may skip DB until the next turn.
 * Send the last `payload.state` as metadata.cvac_state_snapshot so the server
 * can restore session + flush deferred lead/offers/messages.
 *
 * @param {Record<string, unknown>|undefined|null} metadata
 * @param {{ current: unknown }} serverStateRef
 * @returns {Record<string, unknown>}
 */
export function withCvacServerStateMetadata(metadata, serverStateRef) {
  const m =
    metadata && typeof metadata === "object" && !Array.isArray(metadata)
      ? { ...metadata }
      : {};
  const snap = serverStateRef?.current;
  if (snap && typeof snap === "object" && !Array.isArray(snap)) {
    m.cvac_state_snapshot = snap;
  }
  return m;
}

/**
 * @param {unknown} payload — API `data.payload` from a successful turn
 * @param {{ current: unknown }} serverStateRef
 */
export function captureCvacServerStateFromPayload(payload, serverStateRef) {
  if (!serverStateRef) return;
  if (!payload || typeof payload !== "object") return;
  const st =
    payload.state ??
    (payload.payload && typeof payload.payload === "object"
      ? payload.payload.state
      : null);
  if (st && typeof st === "object" && !Array.isArray(st)) {
    serverStateRef.current = st;
  }
}
